module.exports = __webpack_public_path__ + "static/fk-519e3de544b46b3524a5a2bbbc383625.svg";